import React, { useState } from 'react';
import { Folder } from '../../../types';
import icons from '../../../layout/Icons';
import EditFolderModal from './EditFolderModal';
import { useAuth } from '../../../contexts/AuthContext';

interface FolderCardProps {
  folder: Folder;
  onClick: () => void;
  onFolderUpdated?: (updatedFolder: Folder) => void;
}

const FolderCard: React.FC<FolderCardProps> = ({ folder, onClick, onFolderUpdated }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const { state: authState } = useAuth();

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Evitar que se abra la carpeta
    setShowEditModal(true);
  };

  const handleFolderUpdated = (updatedFolder: Folder) => {
    setShowEditModal(false);
    if (onFolderUpdated) {
      onFolderUpdated(updatedFolder);
    }
  };

  return (
    <>
      <div 
        className="folder-card"
        onClick={onClick}
        style={{ marginBottom: '16px' }}
      >
        <div className="folder-card-header">
          <div className="folder-card-icon">
            {icons.Folder}
          </div>
          
          {authState.user?.role === 'admin' && (
            <button
              onClick={handleEditClick}
              className="folder-card-edit-btn"
              title="Editar carpeta"
            >
              {icons.Edit}
            </button>
          )}
        </div>
      
        <div className="folder-card-content">
          <h3 className="folder-card-title">
            {folder.name}
          </h3>
          
          <div className="folder-card-stats">
            {!folder.parent_folder && (
              <span className="folder-card-stat">
                {folder.subfolder_count} carpeta{folder.subfolder_count !== 1 ? 's' : ''}
              </span>
            )}
            <span className="folder-card-stat">
              {folder.document_count} documento{folder.document_count !== 1 ? 's' : ''}
            </span>
          </div>
          
          <div className="folder-card-date">
            {new Date(folder.created_at).toLocaleDateString()}
          </div>
        </div>
      </div>

      {/* Modal de edición */}
    {showEditModal && (
      <EditFolderModal
        folder={folder}
        onClose={() => setShowEditModal(false)}
        onSuccess={handleFolderUpdated}
      />
    )}
  </>
  );
};

export default FolderCard;